import React, { useState } from 'react'
import DepositTable from './components/DepositTable'
import Header from './components/Header'
import { DepositContext } from './context'

function Deposits() {
    const [displaySingleDeposit, setDisplaySingleDeposit] = useState(true)
    const [singleDepositsData, setSingleDepositsData] = useState(true)

    return (
        <DepositContext.Provider value={{ displaySingleDeposit, setDisplaySingleDeposit, singleDepositsData, setSingleDepositsData }}>
            <Header />
            <DepositTable />
        </DepositContext.Provider>
    )
}

export default Deposits
